import React from 'react';
import { toNumberWithCommas } from '../shared/FormatHelpers';

const DisplayNumber = ({ value, isCurrency }) => {
    if (value === null || value === undefined) return null;

    if (!isCurrency) {
        return toNumberWithCommas(value);
    } else {
        const sign = value < 0 ? '-' : '';
        const absoluteValue = Math.abs(value);
        let prettyNumber;
        if (value.toString().includes('.')) {
            prettyNumber = toNumberWithCommas(absoluteValue.toFixed(2));
        } else {
            prettyNumber = toNumberWithCommas(absoluteValue);
        }
        return (
            <div>
                {sign}SEK{prettyNumber}
            </div>
        );
    }
};

export default DisplayNumber;
